import React, { useEffect, useState } from 'react';
import { CommonSevice } from '../../services/common';
import GroupContainer from './GroupContainer';
import BackgroundImage from '../../assets/LandingPage.png';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import Banner from '../../assets/banner.jpg';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function LandPage({ pageId }) {
  const [pageData, setPageData] = useState({});
  const [loading, setLoading] = useState(false);
  const { currentUserRoleId, appPermissions, userInfo } = useSelector(
    (state) => state.main
  );

  useEffect(async () => {
    if (currentUserRoleId) {
      setLoading(false);
      const data = await new CommonSevice().getlandingpage(currentUserRoleId);
      setPageData(data);
      setLoading(true);
    }
  }, [currentUserRoleId]);

  if (!loading) return  <div><Skeleton count={2} height={300} style={{ margin: '20px' }} /></div>;

  return (
    <div style={{ position: 'relative' }}>
      {/* 🔳 Background Image Layer */}
      <div
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'bottom',
          objectPosition: 'bottom',
          height: '100vh',
          width: '100vw',
          margin: '0 auto',
          opacity: 0.5,
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />

      {/* 🔲 Foreground Content */}
      <div style={{ position: 'relative', zIndex: 1, paddingLeft: '5px' }}>
        <div
          style={{
            position: 'relative',
            width: '100%',
            marginTop: '20px',
            height: '20vh',
            overflow: 'hidden',
            borderRadius: '8px',
          }}
        >
          <img
            src={Banner}
            alt="Welcome Banner"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              opacity: 0.9,
              objectPosition: '50% 20%',
              borderRadius: '8px',
            }}
          />

          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              padding: '16px 24px',
              borderRadius: '8px',
            }}
          >
            <Typography
              variant="h4"
              style={{
                fontFamily: '\'Plus Jakarta Sans\', sans-serif',
                color: '#000',
                fontWeight: '1000',
                marginBottom: 8,
                display: 'flex',
                justifyContent: 'center',
              }}
              gutterBottom
            >
              Hello,{' '}
              <span>{userInfo?.displayName && userInfo.displayName}</span>
            </Typography>
            <Typography
              variant="h5"
              style={{
                fontFamily: '\'Plus Jakarta Sans\', sans-serif',
                color: '#000',
                fontWeight: '1000',
              }}
              gutterBottom
            >
              {pageData.page_title || ''}
            </Typography>
          </div>
        </div>
        {pageData?.widgetGroups?.map((group) => (
          <GroupContainer key={group.pk_id} group={group} />
        ))}
      </div>
    </div>
  );
}
